var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"break section-block row-box"},[_vm._l((_vm.data),function(value,index){return _c('WrapperField',{key:value + index + Math.random(),attrs:{"data":_vm.createDataField({
        fieldName: index,
        fieldValue: value,
        fieldGroup: _vm.FieldGroup.TRUSTEE_ORGANIZATION,
      })}})}),_c('TitleField',{attrs:{"fieldName":"isAssignee","fieldGroup":_vm.FieldGroup.ORGANIZATION}}),_c('AssigneeSection',{attrs:{"data":_vm.data.assignee}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }